/**
 * Pure shaping for the taskpane's self-usage view (GID-146). Deliberately
 * drops cost_usd everywhere — this view must show tokens only, never cost
 * (that distinction lives only in the admin dashboard). Keeping the "no
 * cost" rule enforced here, in one pure function, means the render code in
 * taskpane.js can never accidentally leak a cost_usd field into the DOM.
 */
export function formatUsageRows(byModelResponse) {
  const totalTokens = Number(byModelResponse?.total?.tokens) || 0;
  const byModel = Array.isArray(byModelResponse?.by_model) ? byModelResponse.by_model : [];
  const rows = byModel.map((entry) => ({
    model: String(entry.model || "unknown"),
    tokens: Number(entry.tokens) || 0,
  }));
  return { totalTokens, rows };
}

/**
 * Formats the subscription-period range + days-remaining line for the
 * account panel, e.g. "Aug 15 – Sep 14 (12 days left)". period_end is an
 * EXCLUSIVE UTC-midnight boundary (a cycle ending "Sep 15" is stored as
 * 2026-09-15T00:00:00Z), so the displayed end date is one day earlier —
 * the last day the cycle actually covers.
 */
export function formatSubscriptionPeriod(periodData) {
  const start = periodData?.period_start ? new Date(periodData.period_start) : null;
  const end = periodData?.period_end ? new Date(periodData.period_end) : null;
  if (!start || !end || Number.isNaN(start.getTime()) || Number.isNaN(end.getTime())) {
    return null;
  }
  const lastInclusiveDay = new Date(end.getTime() - 24 * 60 * 60 * 1000);
  const fmt = (d) => d.toLocaleDateString("en-US", { month: "short", day: "numeric", timeZone: "UTC" });
  const range = `${fmt(start)} – ${fmt(lastInclusiveDay)}`;
  const daysRemaining = Number(periodData?.days_remaining);
  if (!Number.isFinite(daysRemaining)) return range;
  const clamped = Math.max(0, daysRemaining);
  return `${range} (${clamped} day${clamped === 1 ? "" : "s"} left)`;
}
